const LVVaccinationsDark = () => (
	<g id="LT_Vaccinations, Lovet">
		<g id="Group 1343">
			<path
				id="Vector"
				d="M5.54477 11.7687L11.2299 6.08353L23.3497 18.2033C24.375 19.2286 24.375 20.8974 23.3497 21.9227L21.384 23.8885C20.3587 24.9138 18.6899 24.9138 17.6646 23.8885L5.54477 11.7687Z"
				fill="#AAE2F7"
			/>
			<path
				id="Vector_2"
				d="M6.18225 5.40121L4.86703 6.71643L7.21463 9.06402L8.52985 7.74881L6.18225 5.40121Z"
				fill="#2CA757"
			/>
			<path
				id="Intersect"
				d="M15.6707 10.5245L12.0487 14.1466C11.8535 14.3416 11.5368 14.3415 11.3416 14.1466C11.1466 13.9513 11.1465 13.6348 11.3416 13.4396L14.9637 9.8175L15.6707 10.5245Z"
				fill="#00084D"
			/>
			<path
				id="Intersect_2"
				d="M20.338 15.1945L16.7159 18.8165C16.5207 19.0116 16.2041 19.0114 16.0089 18.8165C15.8138 18.6213 15.8138 18.3047 16.0089 18.1095L19.6299 14.4865L20.338 15.1945Z"
				fill="#00084D"
			/>
			<path
				id="Vector_3"
				d="M12.5019 4.20479L12.4948 4.19771C12.1082 3.81109 11.4814 3.8111 11.0947 4.19772L3.65597 11.6365C3.26935 12.0231 3.26935 12.6499 3.65596 13.0365L3.66304 13.0436C4.04966 13.4302 4.67649 13.4302 5.06311 13.0436L12.5019 5.60485C12.8885 5.21823 12.8885 4.59141 12.5019 4.20479Z"
				fill="#2CA757"
			/>
			<path
				id="Vector_4"
				d="M7.22453 3.94453L7.21745 3.93746C6.83084 3.55084 6.20401 3.55084 5.81739 3.93746L3.40616 6.3487C3.01954 6.73532 3.01953 7.36214 3.40615 7.74876L3.41323 7.75584C3.79985 8.14246 4.42667 8.14245 4.81329 7.75583L7.22453 5.3446C7.61114 4.95798 7.61115 4.33115 7.22453 3.94453Z"
				fill="#2CA757"
			/>
			<path
				id="Vector_5"
				d="M29.2947 28.7627L26.8647 28.7227L21.7147 23.5627L22.9047 22.3727L29.2947 28.7627Z"
				fill="#2CA757"
			/>
		</g>
	</g>
);

export default LVVaccinationsDark;
